module.exports = __webpack_public_path__ + "img/upload.0bb7dd67.svg";